
<p-tree class="parameter-tree" [value]="treeParameters">
  <ng-template let-node  pTemplate="default">
       <span> <i *ngIf="node.tooltip" class="pi pi-exclamation-circle" [pTooltip]='node.tooltip' tooltipPosition="right"></i>
         {{ node.label}}
       </span>
  </ng-template>
</p-tree>

